import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@context/AuthContext";
import { useNotification } from "@context/NotificationContext";
import { consumePendingKeyImport } from "@hooks/useLocalKeys";

/**
 * Applies a key bundle stashed in localStorage (from Welcome / Import Keys) after Google sign-in.
 */
export function PendingKeyImportConsumer() {
  const { isAuthenticated, loading, user } = useAuth();
  const { notify } = useNotification();
  const { t } = useTranslation();

  useEffect(() => {
    if (loading || !isAuthenticated || !user?.id) return;
    let cancelled = false;
    void consumePendingKeyImport().then((count) => {
      if (cancelled || count <= 0) return;
      notify(t("importKeys.applied", { count }), "success");
    });
    return () => {
      cancelled = true;
    };
  }, [loading, isAuthenticated, user?.id]);

  return null;
}
